import React from 'react';

import { JobMatchStageEnum } from '@libs/graphql-types';
import ArrowTabs from '@libs/ui/components/arrow-tabs';
import { TabItemsType } from '@libs/ui/components/arrow-tabs/types';

export interface TabItem {
  id: JobMatchStageEnum;
  label: string;
  count: number;
}

export interface ArrowMatchesTabsProps {
  tabs: TabItem[];
  currentActive: JobMatchStageEnum;
  onChange: (tabId: JobMatchStageEnum) => void;
  className?: string;
}

const ArrowMatchesTabs = ({
  tabs,
  currentActive,
  onChange,
  className,
}: ArrowMatchesTabsProps) => {
  // Transform our TabItem array to the format expected by ArrowTabs
  const items: TabItemsType[] = tabs.map((tab) => ({
    children: `${tab.label}\n(${tab.count})`,
    id: tab.id,
    bg: tab.id === JobMatchStageEnum.Placement ? 'primary' : undefined,
  }));

  // Create a handler that converts string to MatchTypeEnum
  const handleChange = (id: string) => {
    onChange(id as JobMatchStageEnum);
  };

  return (
    <ArrowTabs
      className={className}
      currentActive={currentActive}
      items={items}
      onChange={handleChange}
    />
  );
};

export default ArrowMatchesTabs;
